import { storeInformationQueries } from "$/hooks/use-store-information"
import { findIdToken, reportTokenLostOnLoad } from "$/lib/auth"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth")({
  beforeLoad: async ({ location }) => {
    // Await a genuinely usable token rather than checking that localStorage
    // merely holds one. An expired token used to pass this gate, and the loader
    // below would then fire queries that failed into the generic error screen.
    // A transient failure throws to the error screen rather than /login, so a
    // network blip never logs the store out.
    const idToken = await findIdToken()

    if (!idToken) {
      await reportTokenLostOnLoad()

      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      })
    }
  },
  loader: async ({ context: { queryClient } }) =>
    await queryClient.ensureQueryData(
      storeInformationQueries.detail(queryClient),
    ),
})
